import React, { useEffect, useState } from "react";
import "./DeleteUserModal.css";
import { RootState } from "../../redux/type";
import Button from "../UI/Button";
import { useDispatch, } from "react-redux";
import { deleteUserInDatabase, sendEmailToUser } from "../../redux/createMessage/slice";
import firebase from "../../firebase/config";
import "firebase/firestore";

interface IsendEmailModal {
    setOpenModal: (isOpen: boolean) => void;
    setSelectedUsersEmail : any
    usersEmail : string[]
  }
  

const SendEmailModal = ({ setOpenModal, usersEmail, setSelectedUsersEmail} : IsendEmailModal) =>{
    const dispatch= useDispatch();
    const [emailData, setEmailData] = useState({title : "", description: ""});
    const [success, setSuccess] = useState(""); // to display message if the message is sent or not
    const [error, setError] = useState("");

    console.log("usersEmail in SendEmailModal", usersEmail)

    const getUpdatedEmailContent = (e : any)=>{
      setEmailData((prevMessages) => ({
        ...prevMessages,
        [e.target.name]: e.target.value,
        emails: usersEmail
      }));
    }
    const onSubmitEmailToUser=(e :any )=>{
      e.preventDefault()
      console.log("email data in SendEmailModal", emailData)
      console.log("user mail id in SendEmailModal", usersEmail)
      if(emailData.title.trim()!=="" && emailData.description.trim() !== ""){
        setSuccess("Email sent successfully")
        setError("")
        setSelectedUsersEmail([])
        setTimeout(() => {
          dispatch(sendEmailToUser(emailData)) ;
          setOpenModal(false)
        }, 3000); 
      }else{
        setError("Please fill title and description carefully")
        setSuccess("")
      }
    }

    return (
    <div className="modalBackground">
      <div className="modalContainer">
        <div className="title">
          <h1>Send Email </h1>

          {/* <button className="titleCloseBtn"
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </button> */}

        </div>
        <div className="body py-2" style={{backgroundColor : "white"}}>
            <div className="col-md-12">
                <form onSubmit={onSubmitEmailToUser}>
                    <div className="form-row" style={{margin : "10px"}}>
                        <input type="text" className="form-control" style={{color:"black"}}

                        onChange={getUpdatedEmailContent} 
                        name="title" placeholder="Title" 
                        //  value={title} 
                          />
                    </div> 
                     <div className="form-row" style={{margin : "10px"}}>
                        <textarea className="form-control"  
                        onChange={getUpdatedEmailContent}
                         name = "description" 
                        //  value={description} 
                         style={{lineHeight: "normal", padding:"1.5%", color:"black", height: "200px", resize: "none"}} id="" placeholder="Add your message"></textarea>
                    </div> 

                    {error && <p style={{ color: "red", fontSize: "15px" }}>{error}</p>}
                    {success && <p style={{ color: "green", fontSize: "15px" }}>{success}</p>}

                    <p className="" style={{margin : "0px", padding: "10px 0px"}}>Are you sure want to send email to this user?</p>
                    <div className="footer">
                        <Button type="submit" text="Yes" className="btn btn-danger"/>
                        <Button text="No" className="btn btn-primary" onClick={() => {
                          setSelectedUsersEmail([]) 
                          setOpenModal(false)}
                          }/>
                      </div>                                 
                </form>
            </div>
        </div>
        
      </div>
    </div>
  );
}

export default SendEmailModal;
